import React, { Component } from 'react';
import '../../assets/AdminCss/ScrollableContent.css';
import WhatsAppButton from './WhatsAppButton';
import SliderContainer from './SliderContainer';
import Sliderdown from './Sliderdown';



class ScrollableContent extends Component {


  
  constructor(props) {
    super(props);
    this.state = {
      celebrities: [
        {
          id: 1,
          name: "Pulkit Samrat, Varun Sharma",
          description: "Kheloyar",
          image: "/placeholder-images/celebrity1.jpg",
          videoUrl:null,
          isPlaying: false
        },
        {
          id: 2,
          name: "Daisy Shah",
          description: "Kheloyar",
          image: "/placeholder-images/celebrity2.jpg",
          videoUrl: null,
          isPlaying: false
        },
        {
          id: 3,
          name: "Randeep Hooda",
          description: "Kheloyar",
          image: "/placeholder-images/celebrity3.jpg",
          videoUrl: null,
          isPlaying: false
        },
        {
          id: 4,
          name: "Krushna Abhishek",
          description: "Kheloyar",
          image: "/placeholder-images/celebrity4.jpg",
          videoUrl: null,
          isPlaying: false
        },
        {
          id: 5,
          name: "Boman Irani",
          description: "Kheloyar",
          image: "/placeholder-images/celebrity5.jpg",
          videoUrl: null,
          isPlaying: false
        }
      ],
      providers: [
        { id: 1,  src: "/assets/all_images/sidebar/p1.png" },
        { id: 2,  src: "/assets/all_images/sidebar/p2.png" },
        { id: 3, src: "/assets/all_images/sidebar/p1.png" },
        { id: 4, src:"/assets/all_images/sidebar/p3.png" },
        { id: 5,  src: "/assets/all_images/sidebar/p4.png" },
        { id: 6,  src: "/assets/all_images/sidebar/p5.png" },
        { id: 7, src: "/assets/all_images/sidebar/p6.png" },
        { id: 8, src: "/assets/all_images/sidebar/p2.png" }
      ]
    };
  }
  

  // Helper function to extract YouTube video ID
  getYoutubeId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  }

  // Toggle video play state
  toggleVideo = (celebrityId) => {
    const updatedCelebrities = this.state.celebrities.map(celebrity => {
      if (celebrity.id === celebrityId) {
        return { ...celebrity, isPlaying: !celebrity.isPlaying };
      } else {
        // Stop other videos from playing
        return { ...celebrity, isPlaying: false };
      }
    });
    
    this.setState({ celebrities: updatedCelebrities });
  }

  renderCelebrityCard(celebrity) {
    const videoId = celebrity.videoUrl ? this.getYoutubeId(celebrity.videoUrl) : null;
    
    return (
      <div className="celebrity-card" key={celebrity.id}>
        {celebrity.isPlaying && videoId ? (
          <div className="video-container">
            <iframe 
              width="100%" 
              height="100%" 
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1`} 
              title="YouTube video player" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
            ></iframe>
            <button 
              className="close-video-btn"
              onClick={() => this.toggleVideo(celebrity.id)}
            >
              Close
            </button>
          </div>
        ) : (
          <>
            <img 
              className="celebrity-img" 
              src={celebrity.image} 
              alt={celebrity.name} 
            />
            <div className="celebrity-overlay">
              <div className="celebrity-name">{celebrity.name} - {celebrity.description}</div>
              <div className="tag-row">
                <div className="k-tag">k</div>
                <div className="kheloyar-tag">kheloyar</div>
                <button className="subscribe-btn">Subscribe</button>
              </div>
            </div>
            {celebrity.videoUrl && (
              <div 
                className="play-btn" 
                onClick={() => this.toggleVideo(celebrity.id)}
              >
                <div className="play-icon"></div>
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  renderProviderCard(provider) {
    return (
      <div className="provider-card" key={provider.id}>
        <img className="provider-logo" src={provider.logo} alt={provider.name} />
      </div>
    );
  }

  render() {
    return (
      <div className="scrollable-content">
        {/* Celebrities Section */}
       <div  style={{background:"#1a1a1e"}}  className='mb-2'>
       <div className="section-header">
          <div className="section-title">
            <div className="logo-icon"></div>
            <span>Celebrities</span>
          </div>
        </div>
        
        <div className="scroll-container celebrities">
          {this.state.celebrities.map(celebrity => this.renderCelebrityCard(celebrity))}
        </div>
       </div>
        
        <div style={{border:"2px solid #22222f"}}>
  {/* Providers Section */}
  <div className="section-header">
    <div className="section-title">
      <div className="logo-icon provider-icon"></div>
      <span style={{fontSize:"14px"}}> Providers</span>
    </div>
    <a href="##" className="see-all">
      See All →
    </a>
  </div>
  
  {/* <div className="scroll-container providers" style={{
    display: "flex",
    overflowX: "auto",
    scrollBehavior: "smooth",
    WebkitOverflowScrolling: "touch",
    padding: "10px 0",
    gap: "16px"
  }}>
    {this.state.providers.map(provider => this.renderProviderCard(provider))}
  </div> */}
  <Sliderdown CurrentSlider={this.state.providers}/>
</div>

<>
      <style>
        {`
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {
              transform: translateY(0);
            }
            40% {
              transform: translateY(-25px);
            }
            60% {
              transform: translateY(-25px);
            }
          }
        `}
      </style>

      <a
        href="https://daba.b-cdn.net/images/WA.svg"
        target="_blank"
        rel="noopener noreferrer"
        title="Whatsapp"
        style={{
          position: "fixed",
          width: "35px",
          height: "60px",
          bottom: "141px",
          right: "20px",
          color: "#fff",
          borderRadius: "50px",
          textAlign: "center",
          fontSize: "30px",
          zIndex: 100,
          cursor: "pointer",
        }}
      >
        <img
          src="https://daba.b-cdn.net/images/WA.svg"
          alt="Whatsapp-KHELOYAAR"
          title="Whatsapp"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            animation: "bounce 2s infinite",
            marginTop: "14px",
          }}
        />
      </a>
    </>

  
<div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        position: "fixed",
        bottom: "16px",
        right: "40px",
        zIndex: 100,
      
      }}
    >
      <a
        href="https://daba.b-cdn.net/images/WA.svg"
        target="_blank"
        rel="noopener noreferrer"
        title="Whatsapp"
        style={{
          background: "#2ab63f",
          border: "1px solid white",
          padding: "0px 25px 5px 15px",
          color: "white",
          fontSize: "14px",
          fontWeight: 700,
          textAlign: "left",
          borderRadius: "40px 8px 8px 40px",
          textDecoration: "none",
          position: "relative", // for positioning the image inside
        }}
      >
        Get an ID on Whatsapp
        <img
          src="https://daba.b-cdn.net/images/WA.svg"
          alt="Whatsapp-KHELOYAAR"
          title="Whatsapp"
          style={{
            width: "35px",
            position: "absolute",
            zIndex: 999,
            right: "-18px",
            top: "50%",
            transform: "translateY(-50%)",
          }}
        />
      </a>
    </div>

      </div>
    );
  }
}

export default ScrollableContent;